import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import AppraisalForm from "./AppraisalForm";
import { Typography } from "@mui/material";
import App from "../../App";
import Navbar from "../../components/Page Component/Navbar";
import Footer from "../../components/Page Component/Footer";
import ThreeSixtyForm from "./ThreeSixtyForm/ThreeSixtyForm";
import { CustomTabPanel, a11yProps } from "../../components/TabPanel/TabPanel";
import {
  ToastVariant,
  useCustomToast,
} from "../../components/Methods/SnackBar";
import FeedbackForm from "./Feedback Form/FeedbackForm";

const FormAdd = () => {
  const [value, setValue] = React.useState(0);

  const showToast = useCustomToast();
  const handleShowToast = (
    message: string,
    variant: ToastVariant,
    isCloseable: boolean
  ) => {
    showToast(message, variant, isCloseable);
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    const tempElement = document.createElement("div");
    tempElement.innerHTML = event.currentTarget.innerHTML;
    const tabLabel = tempElement.innerText;

    // Clean up the temporary element
    tempElement.remove();
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "98vw", mt: 10, mb: 10 }}>
      <Box>
        <Tabs
          centered
          value={value}
          onChange={handleChange}
          textColor="inherit"
          indicatorColor="secondary"
          aria-label="secondary tabs example"
        >
          <Tab {...a11yProps(0)} label="Appraisal"></Tab>
          <Tab {...a11yProps(1)} label="360 &deg;" />
          <Tab {...a11yProps(2)} label="Feedback" />
        </Tabs>
        <CustomTabPanel value={value} index={0}>
          <AppraisalForm />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <ThreeSixtyForm />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          <FeedbackForm />
        </CustomTabPanel>
      </Box>
    </Box>
  );
};

export default FormAdd;
